import React from 'react';
import { Link } from 'react-router-dom';

const teamMembers = [
  {
    name: 'Mobi-Coach',
    role: 'Digital Training',
    image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745791478/image_atikqz.png',
    page: 'Advisor',
  },
  {
    name: 'Waste Management',
    role: 'Center of Excellence',
    image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745791478/image-2_bqdgj0.png',
    page: 'Advisor7',
  },
  {
    name: 'Finance',
    role: 'Finance',
    image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1746387791/image_71_pfinhi.png',
    page: 'Advisor1',
  },
];

const iconUrl = 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745791431/Expand_right_11_mvhgkl.png';

const ACE = () => {
  return (
    <div className="md:px-24 px-4 md:mt-16">
      
      {/* Heading and View More */}
      <div className="flex md:gap-4 gap-1 items-center md:mb-3 mb-2">
        <h2 className="text-[#03897B] text-[10px] md:text-[32px] font-bold">
          SERVICES
        </h2>
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746386728/Expand_right_14_xsloli.png"
          alt="l"
          className="md:w-[57px] md:h-[59px] h-[13px] w-[13px]"
        />
      </div>

      {/* Grid Cards */}
      <div className="grid grid-cols-3 sm:grid-cols-3 gap-2 md:gap-4">
        {teamMembers.map((member, index) => (
          <div
            key={index}
            className="relative rounded-md overflow-hidden shadow hover:shadow-lg transition-all duration-300 transform hover:scale-105 hover:brightness-105"
          >
            <Link to={`/${member.page}`} className="block">

              {/* Orange Label Overlay */}
              <div className="absolute md:bottom-16 bottom-4  md:left-6 left-2 bg-[#F38323] text-white text-[5px] sm:text-[12px] md:text-[14px] font-semibold px-2 md:px-4 py-1 rounded-[5px] z-10 w-[70px] md:w-[180px] h-[16px] md:h-[34px] flex items-center">
                {member.role}
              </div>

              {/* Image */}
              {member.image ? (
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-[100px] sm:h-[240px] md:h-[350px] object-cover bg-[#D9D9D9]"
                />
              ) : (
                <div className="w-full h-[140px] sm:h-[240px] md:h-[260px] bg-[#D9D9D9]" />
              )}

              {/* Name and Icon OVERLAY */}
              <div className="absolute bottom-0 left-0 right-0 bg-[#03897B] text-white p-1 md:px-8 md:h-[84px] sm:p-3 flex items-center justify-between">
                <p className="text-[6px] sm:text-[16px] md:text-[32px] font-medium md:mt-1">
                  {member.name}
                </p>
                <img
                  src={iconUrl}
                  alt="Arrow icon"
                  className="w-3 h-3 md:w-[35px] md:h-[35px]  md:mt-1"  
                />
              </div>

            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ACE;
